import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=b999d6bc&scoped=true"
import script from "./Transactions.vue?vue&type=script&lang=ts"
export * from "./Transactions.vue?vue&type=script&lang=ts"
import style0 from "./Transactions.vue?vue&type=style&index=0&id=b999d6bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b999d6bc",
  null
  
)

export default component.exports